import dayJs from 'dayjs';
import { Link } from 'react-router-dom';
import { validate as uuidValidate } from 'uuid';
import { getPageURL, PageURL } from 'router/pageURL';
import { NumericFormat } from 'react-number-format';

export const FormattedTableCell: any = ({ objectKey, value }: any) => {
  if (typeof value !== 'number' && !value) return '-';

  switch (objectKey) {
    case 'createdAt':
    case 'submittedAt':
      return dayJs(value).format('DD/MM/YYYY HH:mm');
    case 'id':
      return uuidValidate(value) ? (
        value
      ) : (
        <Link to={getPageURL(PageURL.APPLICATION_DETAILS, { id: value })} className={'text-blue-500 no-underline'}>
          {value}
        </Link>
      );
    case 'financingAmount':
      return <NumericFormat value={value} displayType={'text'} thousandSeparator={true} prefix='£' />;
    default:
      return value;
  }
};
